/**
 * Created by pajicv on 10/5/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import WorkerSubTask from './WorkerSubTask';
import { spinnerWhileLoading } from '../../utils/components';

const populateProjectMembers = [{
    child: 'members',
    root: 'users',
    populateByKey: true
}];


const enhance = compose(
    firebaseConnect((props) => {
        const { projectId } = props;
        return [{
            path: `projects/${projectId}`,
            populates: populateProjectMembers
        }];
    }),
    connect(
        (state, props) => {
            const { projectId } = props;
            return ({
                project: populate(state.firebase, `projects/${projectId}`, populateProjectMembers),
                auth: state.firebase.auth,
            });
        }
    ),
    spinnerWhileLoading(['project'])
);

export default enhance(WorkerSubTask);



// WEBPACK FOOTER //
// ./src/components/Tasks/WorkerSubTask.enhancer.js